import { combineReducers } from "redux";
import NupViewReducer from "./NupViewReducer";
const listViewReducer = combineReducers({
    NupViewReducer,
});

export default listViewReducer;